import * as Yup from 'yup';

// W-0651 — Validações do form de Altera Código Conta.
// Paridade Delphi Ualteracodigoconta.pas (Edit2 = novo código, Edit4 = observação).
// Inputs type="text" + inputMode="numeric" — validação string + regex (evita efeitos colaterais
// de type="number"). Mensagens literais do Delphi/PRD §5.
export const alterarCodigoContaSchema = Yup.object().shape({
  codigoGrupoEmpresa: Yup.number()
    .typeError('Selecione um GE.')
    .required('Selecione um GE.'),
  codigoContaAtual: Yup.number()
    .typeError('Selecione uma conta.')
    .required('Selecione uma conta.')
    .positive('Selecione uma conta.')
    .integer(),
  codigoContaNovo: Yup.string()
    .required('Novo código obrigatório.')
    .matches(/^\d+$/, 'Novo código deve conter apenas números')
    .test('min1', 'Novo código obrigatório.', (val) => {
      const n = val ? parseInt(val, 10) : 0;
      return n >= 1;
    })
    .test(
      'different-from-atual',
      'Novo código deve ser diferente do atual.',
      function (value) {
        const atual = this.parent.codigoContaAtual;
        if (value == null || value === '' || atual == null || atual === '')
          return true;
        return Number(value) !== Number(atual);
      }
    ),
  observacao: Yup.string()
    .required('Observação obrigatória.')
    .max(255, 'Observação muito longa.'),
});
